import { DATE_FORMATS, DATE_FORMAT_HYPHEN } from 'utilities/constants';
import ActionTypes from './actionTypes';
import dayjs from 'dayjs';

/**
 * Get Ampol Cash Orders list
 * */
export function getCashOrdersList(
  grandParentAccountNumber,
  accountNumber,
  pageSize,
  offset,
  sortColumn,
  sortDirection,
  dateFrom,
  dateTo,
  orderNumber,
  orderValueFrom,
  orderValueTo,
  orderStatus,
  cardNumber,
  searchOrderNumber
) {
  return {
    type: ActionTypes.CASH.ORDERS_LIST.REQUEST,
    payload: {
      grandParentAccountNumber,
      accountNumber,
      pageSize,
      offset,
      sortColumn,
      sortDirection,
      dateFrom: dayjs(dateFrom, DATE_FORMATS).format(DATE_FORMAT_HYPHEN),
      dateTo: dayjs(dateTo, DATE_FORMATS).format(DATE_FORMAT_HYPHEN),
      orderNumber,
      orderValueFrom,
      orderValueTo,
      status: orderStatus,
      cardNumber,
      searchOrderNumber,
    },
  };
}

export function getCashOrdersListSuccess(response) {
  return {
    type: ActionTypes.CASH.ORDERS_LIST.SUCCESS,
    payload: {
      cashOrdersList: response.orders.result,
      cashOrdersListResultSize: response.orders.resultSize,
      cashOrderCardDetails: response.card,
    },
  };
}

export function getCashOrdersListFailure() {
  return {
    type: ActionTypes.CASH.ORDERS_LIST.FAILURE,
  };
}

export function getCashOrdersListReset() {
  return {
    type: ActionTypes.CASH.ORDERS_LIST.RESET,
  };
}

/**
 * Get Ampol Cash Order Details
 * */
export function getCashOrderDetails(orderNumber, grandParentAccountNumber, contractIdentifier, pageNumber, pageSize) {
  return {
    type: ActionTypes.CASH.ORDER_DETAILS.REQUEST,
    payload: {
      orderNumber,
      grandParentAccountNumber,
      contractIdentifier,
      pageNumber,
      pageSize,
    },
  };
}

export function getCashOrderDetailsSuccess(response, pageNumber) {
  return {
    type: ActionTypes.CASH.ORDER_DETAILS.SUCCESS,
    payload: {
      cashOrderDetails: response,
      currentCashOrderCardDetailsPageNumber: pageNumber,
    },
  };
}

export function getCashOrderDetailsFailure() {
  return {
    type: ActionTypes.CASH.ORDER_DETAILS.FAILURE,
  };
}

export function getCashOrderDetailsReset() {
  return {
    type: ActionTypes.CASH.ORDER_DETAILS.RESET,
  };
}

/**
 * Get Ampol Cash Card Details
 * */
export function getCashCardDetails(orderNumber, grandParentAccountNumber, contractIdentifier, cardNumber) {
  return {
    type: ActionTypes.CASH.CARD_DETAILS.REQUEST,
    payload: {
      orderNumber,
      grandParentAccountNumber,
      contractIdentifier,
      cardNumber,
    },
  };
}

export function getCashCardDetailsSuccess(response) {
  return {
    type: ActionTypes.CASH.CARD_DETAILS.SUCCESS,
    payload: {
      cashCardDetails: response,
    },
  };
}

export function getCashCardDetailsFailure() {
  return {
    type: ActionTypes.CASH.CARD_DETAILS.FAILURE,
  };
}

export function getCashCardDetailsReset() {
  return {
    type: ActionTypes.CASH.CARD_DETAILS.RESET,
  };
}

export function getCashOrderDefaults(grandParentAccountNumber, contractIdentifier) {
  return {
    type: ActionTypes.CASH.ORDER_DEFAULTS.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
    },
  };
}

export function getCashOrderDefaultsSuccess(response) {
  return {
    type: ActionTypes.CASH.ORDER_DEFAULTS.SUCCESS,
    payload: {
      cashOrderDefaults: response,
    },
  };
}

export function getCashOrderDefaultsFailure() {
  return {
    type: ActionTypes.CASH.ORDER_DEFAULTS.FAILURE,
  };
}

export function addCartItem(item) {
  return {
    type: ActionTypes.CASH.ADD_CART_ITEM,
    payload: {
      cartItem: item,
    },
  };
}

export function deleteCartItem(itemId) {
  return {
    type: ActionTypes.CASH.DEL_CART_ITEM,
    payload: {
      cartItemId: itemId,
    },
  };
}

export function editCartItem(item) {
  return {
    type: ActionTypes.CASH.EDIT_CART_ITEM,
    payload: {
      cartItem: item,
    },
  };
}

export function editCartMediaType(mediaType) {
  return {
    type: ActionTypes.CASH.EDIT_CART_MEDIA_TYPE,
    payload: {
      mediaType,
    },
  };
}

export function resetOrder() {
  return {
    type: ActionTypes.CASH.RESET_ORDER,
  };
}

export function setShippingMethod(method, cost) {
  return {
    type: ActionTypes.CASH.SET_SHIPPING_METHOD,
    payload: {
      shippingMethod: method,
      shippingCost: cost,
    },
  };
}

export function setOrderDiscount(discountPercent) {
  return {
    type: ActionTypes.CASH.SET_ORDER_DISCOUNT,
    payload: {
      discountPercent: discountPercent,
    },
  };
}

export function setAdditionalInformation(requestedName, requestedPhone, caseNumber, purchaseOrderNumber) {
  return {
    type: ActionTypes.CASH.SET_ADDITIONAL_INFORMATION,
    payload: {
      requestedName,
      requestedPhone,
      caseNumber,
      purchaseOrderNumber,
    },
  };
}

export function setShippingWaived(isWaived) {
  return {
    type: ActionTypes.CASH.SET_SHIPPING_WAIVED,
    payload: {
      isFeeWaiveOverride: isWaived,
    },
  };
}

export function setDeliveryOption(option) {
  return {
    type: ActionTypes.CASH.SET_DELIVERY_OPTION,
    payload: {
      option,
    },
  };
}

export function setSingleShippingAddress(address) {
  return {
    type: ActionTypes.CASH.SET_SINGLE_SHIPPING_ADDRESS,
    payload: {
      address,
    },
  };
}

export function setPhysicalAddressRecipient(recipient) {
  return {
    type: ActionTypes.CASH.SET_PHYSICAL_ADDRESS_RECIPIENT,
    payload: {
      recipient,
    },
  };
}

export function removePhysicalAddressRecipient() {
  return {
    type: ActionTypes.CASH.REMOVE_PHYSICAL_ADDRESS_RECIPIENT,
  };
}

export function setCartItemRecipient(cartItemUuid, recipient) {
  return {
    type: ActionTypes.CASH.SET_CART_ITEM_RECIPIENT,
    payload: {
      cartItemUuid,
      recipient,
    },
  };
}

export function removeCartItemRecipient(cartItemUuid, recipient) {
  return {
    type: ActionTypes.CASH.REMOVE_CART_ITEM_RECIPIENT,
    payload: {
      cartItemUuid,
      recipient,
    },
  };
}

/**
 * Create AmpolCash Order
 * */
export function createCashOrder(grandParentAccountNumber, accountNumber, request) {
  return {
    type: ActionTypes.CASH.CREATE_ORDER.REQUEST,
    payload: {
      grandParentAccountNumber,
      accountNumber,
      request,
    },
  };
}

export function createCashOrderSuccess(response) {
  return {
    type: ActionTypes.CASH.CREATE_ORDER.SUCCESS,
    payload: {
      createCashOrderResponse: response,
    },
  };
}

export function createCashOrderFailure() {
  return {
    type: ActionTypes.CASH.CREATE_ORDER.FAILURE,
  };
}

/**
 * Activate all AmpolCash order cards
 * */
export function activateAllCards(orderNumber, contractIdentifier, grandParentAccountNumber) {
  return {
    type: ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.REQUEST,
    payload: {
      orderNumber,
      contractIdentifier,
      grandParentAccountNumber,
    },
  };
}

export function activateAllCardsSuccess() {
  return {
    type: ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.SUCCESS,
  };
}

export function activateAllCardsFailure() {
  return {
    type: ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.FAILURE,
  };
}

export function activateAllCardsReset() {
  return {
    type: ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.RESET,
  };
}

export function setOrderCardDetailsPageNumber(pageNumber) {
  return {
    type: ActionTypes.CASH.SET_ORDER_CARD_DETAILS_PAGE_NUMBER,
    payload: {
      pageNumber: pageNumber,
    },
  };
}

export function setStepId(stepId) {
  return {
    type: ActionTypes.CASH.SET_MODAL_STEP,
    payload: {
      stepId,
    },
  };
}
